import homeDesktop from '@/assets/home_desktop.svg';
import homeMobile from '@/assets/home_mobile.svg';
import homeWebApp from '@/assets/home_webApp.svg';
import desktopAppDevelopmentImg from '@/assets/service_desktopAppDevelopment.svg';
import integrationsImg from '@/assets/service_integrations.svg';
import mobileAppDevelopmentImg from '@/assets/service_mobileAppDevelopment.svg';
import pluginDevelopmentImg from '@/assets/service_pluginDevelopment.svg';
import softwareMaintenanceImg from '@/assets/service_softwareMaintenance.svg';
import webAppDevelopmentImg from '@/assets/service_webAppDevelopment.svg';

export enum ServiceType {
  all = 'all',
  webAppDevelopment = 'webAppDevelopment',
  mobileAppDevelopment = 'mobileAppDevelopment',
  desktopAppDevelopment = 'desktopAppDevelopment',
  pluginDevelopment = 'pluginDevelopment',
  integrations = 'integrations',
  softwareMaintenance = 'softwareMaintenance',
}

export interface ServiceItem {
  id: string;
  type: ServiceType;
  titleKey: string;
  descriptionKey: string;
  serviceImage: string;
  homeSection?: {
    description: string;
    image: string;
  };
}

export const serviceItems: ServiceItem[] = [
  {
    id: 'web-app-development',
    type: ServiceType.webAppDevelopment,
    titleKey: 'serviceItems:webAppDevelopment:title',
    descriptionKey: 'serviceItems:webAppDevelopment:description',
    serviceImage: webAppDevelopmentImg,
    homeSection: {
      description: 'serviceItems:webAppDevelopment:intro',
      image: homeWebApp,
    },
  },
  {
    id: 'mobile-app-development',
    type: ServiceType.mobileAppDevelopment,
    titleKey: 'serviceItems:mobileAppDevelopment:title',
    descriptionKey: 'serviceItems:mobileAppDevelopment:description',
    serviceImage: mobileAppDevelopmentImg,
    homeSection: {
      description: 'serviceItems:mobileAppDevelopment:intro',
      image: homeMobile,
    },
  },
  {
    id: 'desktop-app-development',
    type: ServiceType.desktopAppDevelopment,
    titleKey: 'serviceItems:desktopAppDevelopment:title',
    descriptionKey: 'serviceItems:desktopAppDevelopment:description',
    serviceImage: desktopAppDevelopmentImg,
    homeSection: {
      description: 'serviceItems:desktopAppDevelopment:intro',
      image: homeDesktop,
    },
  },
  {
    id: 'plugin-development',
    type: ServiceType.pluginDevelopment,
    titleKey: 'serviceItems:pluginDevelopment:title',
    descriptionKey: 'serviceItems:pluginDevelopment:description',
    serviceImage: pluginDevelopmentImg,
  },
  {
    id: 'integrations',
    type: ServiceType.integrations,
    titleKey: 'serviceItems:integrations:title',
    descriptionKey: 'serviceItems:integrations:description',
    serviceImage: integrationsImg,
  },
  {
    id: 'software-maintenance',
    type: ServiceType.softwareMaintenance,
    titleKey: 'serviceItems:softwareMaintenance:title',
    descriptionKey: 'serviceItems:softwareMaintenance:description',
    serviceImage: softwareMaintenanceImg,
  },
];
